import React, { JSX, useState } from 'react';

import { useSnackbar } from 'notistack';
import fileDownload from 'react-file-download';
import { Helmet } from 'react-helmet';

import { Button, CircularProgress, Container } from '@mui/material';

import { useGetMessageArchiveRenderedHtml } from '~/hooks/apis/customer-communication/useMessageArchives';

import { htmlToPdf } from '~/services/PDFService';

import Spinner from '../../Common/Spinner';

function RenderMarketingEmailPage(): JSX.Element {
  const [isConvertingHtmlToPdf, setIsConvertingHtmlToPdf] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const id = new URLSearchParams(window.location.search).get('id') ?? '';

  const { data: htmlContent = '', isLoading, isError } = useGetMessageArchiveRenderedHtml(id);

  if (isError) {
    enqueueSnackbar('Failed to load email content', { variant: 'error' });
  }

  async function handleHtmlToPdf(html: string) {
    try {
      setIsConvertingHtmlToPdf(true);
      const pdf = await htmlToPdf(html);
      await fileDownload(pdf, `${id}.pdf`);
    } catch {
      enqueueSnackbar('Unable to convert to pdf', { variant: 'error' });
    } finally {
      setIsConvertingHtmlToPdf(false);
    }
  }

  if (isConvertingHtmlToPdf) return <Spinner />;
  if (isLoading) return <CircularProgress />;

  return (
    <Container>
      <Container>
        <Helmet>
          <title>View Marketing Email</title>
        </Helmet>
        <Button
          onClick={() => handleHtmlToPdf(`<div style="max-width: 75%; margin: 0 auto;">${htmlContent}</div>`)}
          disabled={!htmlContent || isConvertingHtmlToPdf}
        >
          Download as PDF
        </Button>
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </Container>
    </Container>
  );
}

export default RenderMarketingEmailPage;
